import moment from "moment";
import Chart from "react-apexcharts";

const IssuesStatusChart = (props: any) => {
  const {
    ReportsTicketsTotalCountsData,
    ReportsTicketsRaisedData,
    filtertype,
    startDateValue,
    endDateValue,
  } = props;

  // const convertedObject: any = {};
  // let sum = 0;
  // if (startDateValue == endDateValue) {
  //   for (const timestamp in ReportsTicketsRaisedData?.chartData?.data) {
  //     const date = new Date(parseInt(timestamp));
  //     const month = date.getMonth() + 1; // Months are zero-based, so add 1
  //     const day = date.getDate();
  //     const year = date.getFullYear();
  //     // Format the date as mm-dd-yyyy
  //     const formattedDate = day + "-" + month + "-" + year;
  //     sum += ReportsTicketsRaisedData?.chartData?.data[timestamp];
  //     convertedObject[formattedDate] = sum;
  //   }
  // } else {
  //   for (const timestamp in ReportsTicketsRaisedData?.chartData?.data) {
  //     const date = new Date(parseInt(timestamp));
  //     const month = date.getMonth() + 1; // Months are zero-based, so add 1
  //     const day = date.getDate();
  //     const year = date.getFullYear();
  //     // Format the date as mm-dd-yyyy
  //     const formattedDate = day + "-" + month + "-" + year;
  //     convertedObject[formattedDate] =
  //       ReportsTicketsRaisedData?.chartData?.data[timestamp];
  //   }
  // }
  // ReportsTicketsTotalCountsData &&
  //   ReportsTicketsTotalCountsData.chartData &&
  //   ReportsTicketsTotalCountsData.chartData.length > 0 &&
  //   ReportsTicketsTotalCountsData.chartData.forEach((dataItem: any, i: any) => {
  //     const dateKey = dataItem.categories; // Assuming the categories value is a valid date format
  //     const date = new Date(dateKey);
  //     // Extract the components of the date (month, day, year)
  //     const month = date.getMonth() + 1; // Months are zero-based, so add 1
  //     const day = date.getDate();
  //     const year = date.getFullYear();
  //     // Format the date as mm-dd-yyyy
  //     const formattedDate = day + "-" + month + "-" + year;
  //     if (convertedObject.hasOwnProperty(formattedDate)) {
  //       // Categories match, update the values
  //       ReportsTicketsTotalCountsData.chartData[i]["ticketRaisedCount"] =
  //         convertedObject[formattedDate]; // You can update other values similarly if needed
  //     } else {
  //       ReportsTicketsTotalCountsData.chartData[i]["ticketRaisedCount"] = 0;
  //     }
  //   });

  // const dataArray = [
  //   {
  //     "categories": "20-11-2023",
  //     "totalMessageCount": 8,
  //     "promptToRaiseTicketCount": 0,
  //     "botAnsweredCount": 8
  //   },
  //   {
  //     "categories": "20-11-2023",
  //     "totalMessageCount": 8,
  //     "promptToRaiseTicketCount": 0,
  //     "botAnsweredCount": 8
  //   },
  // ];

  const cats: any[] = [];
  const totalNewTicketCount: any[] = [];
  const totalClosedTicketCount: any[] = [];

  ReportsTicketsTotalCountsData &&
    ReportsTicketsTotalCountsData.chartData &&
    ReportsTicketsTotalCountsData.chartData.length > 0 &&
    ReportsTicketsTotalCountsData.chartData.map((e: any) => {
      const date = new Date(e.categories);
      // Extract the components of the date (month, day, year)
      const month = date.getMonth() + 1; // Months are zero-based, so add 1
      const day = date.getDate();
      const year = date.getFullYear();
      // Format the date as mm-dd-yyyy
      const formattedDate = day + "-" + month + "-" + year;
      cats.push(moment(date, "DD-MM-YYYY").format("MM-DD-YYYY"));
    });
  ReportsTicketsTotalCountsData &&
    ReportsTicketsTotalCountsData.chartData &&
    ReportsTicketsTotalCountsData.chartData.length > 0 &&
    ReportsTicketsTotalCountsData.chartData.map((e: any) => {
      totalNewTicketCount.push(e.totalNewTicketCount);
    });

  ReportsTicketsTotalCountsData &&
    ReportsTicketsTotalCountsData.chartData &&
    ReportsTicketsTotalCountsData.chartData.length > 0 &&
    ReportsTicketsTotalCountsData.chartData.map((e: any) => {
      totalClosedTicketCount.push(e.totalClosedTicketCount);
    });

  function getWeekKey(dateString: any) {
    const [day, month, year] = dateString.split("-").map(Number);
    const date = new Date(year, month - 1, day); // Adjust month to be zero-based
    const dayOfWeek = date.getDay();
    const daysSinceStartOfWeek = (dayOfWeek + 6) % 7; // Calculate days since the start of the week

    const weekStart = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate() - daysSinceStartOfWeek
    );
    return weekStart.toISOString().split("T")[0];
  }
  const groupedByWeeks =
    ReportsTicketsTotalCountsData &&
    ReportsTicketsTotalCountsData.chartData &&
    ReportsTicketsTotalCountsData.chartData.length > 0 &&
    ReportsTicketsTotalCountsData.chartData.reduce((result: any, item: any) => {
      const date = new Date(item.categories);
      // Extract the components of the date (month, day, year)
      const month = date.getMonth() + 1; // Months are zero-based, so add 1
      const day = date.getDate();
      const year = date.getFullYear();
      // Format the date as mm-dd-yyyy
      const formattedDate = day + "-" + month + "-" + year;
      const weekKey = getWeekKey(formattedDate);
      result[weekKey] = result[weekKey] || [];
      result[weekKey].push(item);
      return result;
    }, {});
  const weeklyCats = Object.keys(groupedByWeeks);

  const weeklytotalNewTicketCount = Object.keys(groupedByWeeks).reduce(
    (result: any, week: any) => {
      const weekTotal = groupedByWeeks[week].reduce(
        (weekSum: any, item: any) => weekSum + item.totalNewTicketCount,
        0
      );
      result[week] = weekTotal;
      return result;
    },
    {}
  );

  const weeklytotalNewTicketCountArray = Object.values(
    weeklytotalNewTicketCount
  );

  const weeklytotalClosedTicketCount = Object.keys(groupedByWeeks).reduce(
    (result: any, week: any) => {
      const weekTotal = groupedByWeeks[week].reduce(
        (weekSum: any, item: any) => weekSum + item.totalClosedTicketCount,
        0
      );
      result[week] = weekTotal;
      return result;
    },
    {}
  );
  const weeklytotalClosedTicketCountArray = Object.values(
    weeklytotalClosedTicketCount
  );

  const groupedByMonths =
    ReportsTicketsTotalCountsData &&
    ReportsTicketsTotalCountsData.chartData &&
    ReportsTicketsTotalCountsData.chartData.length > 0 &&
    ReportsTicketsTotalCountsData.chartData.reduce((result: any, item: any) => {
      const date = new Date(item.categories);
      // Extract the components of the date (month, day, year)
      const month = date.getMonth() + 1; // Months are zero-based, so add 1
      const day = date.getDate();
      const year = date.getFullYear();
      // Format the date as mm-dd-yyyy
      const formattedDate = day + "-" + month + "-" + year;
      const monthKey = getMonthKey(formattedDate);
      result[monthKey] = result[monthKey] || [];
      result[monthKey].push(item);
      return result;
    }, {});

  function getMonthKey(dateString: any) {
    const [day, month, year] = dateString.split("-").map(Number);
    const date = new Date(year, month - 1, day); // Adjust month to be zero-based
    const monthKey = date.toLocaleString("en-us", {
      month: "short",
      year: "numeric",
    });
    return monthKey;
  }

  const monthlyCats = Object.keys(groupedByMonths);

  const monthlytotalNewTicketCount = Object.keys(groupedByMonths).reduce(
    (result: any, month: any) => {
      const monthTotal = groupedByMonths[month].reduce(
        (monthSum: any, item: any) => monthSum + item.totalNewTicketCount,
        0
      );
      result[month] = monthTotal;
      return result;
    },
    {}
  );
  const monthlytotalNewTicketCountArray = Object.values(
    monthlytotalNewTicketCount
  );

  const monthlytotalClosedTicketCount = Object.keys(groupedByMonths).reduce(
    (result: any, month: any) => {
      const monthTotal = groupedByMonths[month].reduce(
        (monthSum: any, item: any) => monthSum + item.totalClosedTicketCount,
        0
      );
      result[month] = monthTotal;
      return result;
    },
    {}
  );
  const monthlytotalClosedTicketCountArray = Object.values(
    monthlytotalClosedTicketCount
  );

  const series = [
    {
      name: "New Tickets",
      data:
        filtertype == "weekly"
          ? weeklytotalNewTicketCountArray
          : filtertype == "monthly"
          ? monthlytotalNewTicketCountArray
          : totalNewTicketCount,
    },
    {
      name: "Closed Tickets",
      data:
        filtertype == "weekly"
          ? weeklytotalClosedTicketCountArray
          : filtertype == "monthly"
          ? monthlytotalClosedTicketCountArray
          : totalClosedTicketCount,
    },
  ];
  const data: any = {
    options: {
      tooltip: {
        shared: true,
        intersect: false,
        x: {
          format: "dd MMM",
          formatter: function (value: string | number | Date, {}: any) {
            return moment(new Date(value), "DD-MM-YYYY").format("DD MMM");
          },
        },
      },
      chart: {
        id: "idChart",
        type: "bar",
        height: 200,
        stacked: true,
        toolbar: {
          show: true,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true,
          },
          // tools: {
          //   download: true, // <== line to add
          // },
        },
        zoom: {
          enabled: true,
        },
      },
      responsive: [
        {
          breakpoint: undefined,
          options: {},
        },
      ],
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        bar: {
          columnWidth: "35%",
          distributed: false,
          // borderRadius: 10,
          dataLabels: {
            total: {
              enabled: false,
              style: {
                fontSize: "13px",
                fontWeight: 900,
              },
            },
          },
        },
      },
      xaxis: {
        type: "category",
        categories:
          filtertype == "weekly"
            ? weeklyCats
            : filtertype == "monthly"
            ? monthlyCats
            : cats,
      },
      colors: ["#AEE4A1", "#FF9D73", "#738cff"],
      legend: {
        position: "top",
        horizontalAlign: "right",
        offsetY: 30,
        // fontWeight: "bold",
        fill: {
          colors: ["#AEE4A1", "#FF9D73", "#738cff"],
        },
      },
      fill: {
        opacity: 1,
        colors: ["#AEE4A1", "#FF9D73", "#738cff"],
      },
      grid: {
        show: true,
        // borderColor: "#90A4AE",
        strokeDashArray: 0,
        position: "back",
        xaxis: {
          lines: {
            show: true,
          },
        },
        yaxis: {
          offsetY: 50,
          lines: {
            show: true,
          },
        },
        row: {
          colors: undefined,
          opacity: 0.5,
        },
        column: {
          colors: undefined,
          opacity: 0.5,
        },
        padding: {
          top: 5,
          right: 12,
          bottom: 0,
          left: 12,
        },
      },
    },
  };

  return (
    <>
      <Chart options={data.options} series={series} type="bar" height={303} />
    </>
  );
};
export default IssuesStatusChart;
